import { render, staticRenderFns } from "./ArticlePartComponent.vue?vue&type=template&id=171b6102&scoped=true&"
import script from "./ArticlePartComponent.vue?vue&type=script&lang=js&"
export * from "./ArticlePartComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePartComponent.vue?vue&type=style&index=0&id=171b6102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b6102",
  null
  
)

export default component.exports